<template>
  <v-app class="bckgrnd">

    <v-card class="form-container" style="border:1px solid" v-if="dialog1==true">
        <div style="text-align:right">
          <p class="hvr" @click="updialog()">Change username and password</p>
        </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 style="text-align:center">
                <v-avatar size="100" >
                <avatar :size="100" :username="loggedInUserName"></avatar>
             </v-avatar>
                <h4 style="padding-top:20px">My Profile</h4>
            </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.fullName" label="Full name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.mobileNumber" type="Number" label="Mobile number *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 style="text-align:right">
            <v-btn :loading="btnSave" depressed color="black" dark @click="onSubmit()">Save</v-btn>
          </v-flex>

        </v-layout>
      </v-form>
    </v-card>

    <v-card class="form-container"  style="border:1px solid;" v-if="dialog2==true">
      <div style="text-align:right">
          <p class="hvr" @click="mpdialog()">Edit profile</p>
        </div>
      <div style="text-align:center;padding-bottom:15px">
        <v-avatar size="100" >
                <avatar :size="100" :username="loggedInUserName"></avatar>
             </v-avatar>
      </div>
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 style="padding-top:15px">
            <h3>Change Password</h3>
            <v-text-field
              type="password"
              v-model="currentPassword"
              label="Current Password *"
              :rules="emptyRule"
              required
            ></v-text-field>
            <v-text-field
              :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
              :type="passwordShow ? 'text' : 'password'"
              @click:append="passwordShow = !passwordShow"
              v-model="newPassword"
              label="New password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
            <v-text-field
              :append-icon="passwordShow1 ? 'visibility_off' : 'visibility'"
              :type="passwordShow1 ? 'text' : 'password'"
              @click:append="passwordShow1 = !passwordShow1"
              v-model="confirmPassword"
              label="Confirm password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
            <div style="text-align:right">
              <v-btn color="green" v-if="currentPassword != null && newPassword != null && confirmPassword != null" :loading="btnSave1" depressed dark @click="onSubmit1()">Save</v-btn>
            </div>
          </v-flex>

          <v-flex xs12 sm12 md6 style="padding-top:15px;padding-left:10px">
            <h3>Change Username</h3>
            <v-text-field
              v-model="currentUserName"
              label="Current Username *"
            ></v-text-field>
            <v-text-field
              v-model="userName"
              label="Username *"
            ></v-text-field>
            <div style="text-align:right" v-if="currentUserName != null && userName != null">
              <v-btn color="green" :loading="btnSave2" depressed dark @click="onSubmit2()">Save</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
import config from "../../config.json";
export default {
    components: {
   Avatar,
  },
  data() {
    return {
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,
      btnSave1: false,
      btnSave2: false,

      dialog1: true,
      dialog2: false,

      passwordShow: false,
      passwordShow1: false,
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,

      userName: null,
      currentUserName: null,

      form1: {},


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
      valid: true,
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Teacher",
          disabled: false,
          to: "/teacher"
        },
        {
          text: "Create teacher",
          disabled: true,
          to: "/createTeacher"
        }
      ],

      form: {
      }
    };
  },

  mounted() {
    this.getData();
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    updialog() {
      this.dialog1 = false;
      this.dialog2 = true;
    },
    mpdialog() {
      this.dialog2 = false;
      this.dialog1 = true;
    },

    getData() {
      this.axios
      .get(config.API + `MyProfile`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.currentUserName = res.data.userName;
        this.currentPassword = res.data.passwords;
      });
    },

    onSubmit1() {
        this.btnSave1 = true;
        this.axios
          .put(
            config.API + `PasswordChange/` + this.form.userId,
            {
              currentPassword: this.currentPassword,
              newPassword: this.newPassword,
              confirmPassword: this.confirmPassword
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Password updated successful");
            this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave1 = false;
          });
    },


    onSubmit2() {
        this.btnSave2 = true;
        this.axios
          .put(
            config.API + `UpdateProfile/` + this.form.userId,
            {
              id: this.form.userId,
              userName: this.userName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Username updated successful");
            this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave1 = false;
          });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Customers/${this.form.id}`,
            {
              id: JSON.parse(this.form.id),
              fullName: this.form.fullName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              email: this.form.email
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
</style>
